import React, {useEffect, useState} from 'react'
import Button from '../../../components/button/Button'
import OrderList from './OrderList'
import axios from "axios";
import { useTranslation } from 'react-i18next';

const Orders = ({setStateBuyOrder, setOrderType}) => {
    const {t} = useTranslation()
    const token = localStorage.getItem('token')
    const url = new URL(window.location.href);
    let symbolURL = (url.searchParams.get('symbol')) || "BTCUSDT";

    let BalanceID = ""
    if (symbolURL.length === 7){
        BalanceID = symbolURL[0].toLowerCase() + symbolURL[1].toLowerCase() + symbolURL[2].toLowerCase();
    }
    else{
        BalanceID = symbolURL[0].toLowerCase() + symbolURL[1].toLowerCase() + symbolURL[2].toLowerCase() + symbolURL[3].toLowerCase();
    }

    const [isLoadedOrdersTable, setIsLoadedOrdersTable] = useState(false)
    
    const [userOrdersClose, setUserOrdersClose] = useState([])
    const [userOrdersClosedTotal, setUserOrdersClosedTotal] = useState(0)

    const [userOrdersWaiting, setUserOrdersWaiting] = useState([])
    const [userOrdersWaitingTotal, setUserOrdersWaitingTotal] = useState(0)

    const [userOrdersOpen, setUserOrdersOpen] = useState([])
    const [userOrdersOpenTotal, setUserOrdersOpenTotal] = useState(0)

    const [userBalance, setUserBalance] = useState()
    const [AVGdata, setAVGdata] = useState([])

    const requireAVGdata = () => axios.get(`https://api.binance.com/api/v3/ticker/24hr?symbol=${symbolURL}`)
        .then(res => {
            setAVGdata(res.data);
            setTimeout(() => requireAVGdata(), 2000)
        })
    const requireUserBalance = () => axios.get(
        `https://api-ru.fynex.cc/api/api/users/balance/invest`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setUserBalance(res.data[`${BalanceID}`]);
        })
        .catch((err) => {console.error(err)})

    const requireUserDataClosed = () => axios.get(
        `https://api-ru.fynex.cc/api/api/share/close?size=50&page=${1}`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setUserOrdersClose(res.data.items);
            setUserOrdersClosedTotal(res.data.total);
            console.log(res.data)
        })
        .catch((err) => {console.error(err)})
    const requireUserDataWaiting = () => axios.get(
        `https://api-ru.fynex.cc/api/api/share/waiting?size=50&page=${1}`,
        {
            headers: {"Authorization" : `Bearer ${token}`}
        })
        .then(res => {
            setUserOrdersWaiting(res.data.items);
            setUserOrdersWaitingTotal(res.data.total);
            setIsLoadedOrdersTable(true)
            console.log(res.data)
        })
        .catch((err) => {console.error(err)})

    const requireUserDataOpen = () => {
        axios.get(
            `https://api-ru.fynex.cc/api/api/share/open?size=50&page=${1}`,
            {
                headers: {"Authorization" : `Bearer ${token}`}
            })
            .then(res => {
                setUserOrdersOpen(res.data.items);
                setUserOrdersOpenTotal(res.data.total);
                console.log(res.data)
            })
            .catch((err) => {console.error(err)})
    }
    useEffect(() => {
        requireUserDataOpen()
        requireUserDataClosed()
        requireUserDataWaiting()
    }, [])

    const orders = [
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: true, //green
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043" 
            }
        },
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: false, //red
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043" 
            }
        },
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: true, //green
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043"
            }
        },
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: false, //red
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043"
            }
        },
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: true, //green
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043"
            }
        },
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: false, //red
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043"
            }
        },
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: true, //green
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043" 
            }
        },
        {
            limitOrders: "BTC / USDT",
            count: "0.023 ",
            count2: "/ 0.03",
            price: "65,713",
            date: "11-11-24 13:31",
            color: true, //green
            data:{
                currency:"BTCUSDT",
                progression: 5,
                text: "TP / SL    -- / -",
                size: 250,
                pnl: "+32.78 USDT (+1.48%)",
                marza: "100 USDT",
                priceLogIn: "65,835",
                currentPrice: "65,901",
                liquidationPrice: "65,043" 
            }
        }
    ]

    const [activeList, setActiveList] = useState(1)

    useEffect(() => {
        console.log(activeList)
    }, [activeList]);
  return (
    <div className='Orders'>

        <div className="orders-menu">
            <span onClick={() => setActiveList(1)} className={activeList === 1 ? "orders-menu-active" : ""} >
                <p className='p-activ'>{t("ordser.openOrder")} ({userOrdersOpenTotal ? userOrdersOpenTotal : "0"})</p>
                <div className="line line-active"></div>
            </span>
            <span onClick={() => setActiveList(2)} className={activeList === 2 ? "orders-menu-active" : ""} >
                <p>{t("ordser.historyOrders")}({userOrdersClosedTotal ? userOrdersClosedTotal : "0"})</p>
                <div className="line"></div>
            </span>
            <span onClick={() => setActiveList(3)} className={activeList === 3 ? "orders-menu-active" : ""} >
                <p>{t("ordser.awaitOrders")}({userOrdersWaitingTotal ? userOrdersWaitingTotal : "0"})</p>
                <div className="line"></div>
            </span>
        </div>

        {activeList === 1 && <div className={orders.length > 0 ? "order-list" : "order-list null-order-list"}>
            {isLoadedOrdersTable ?


                <ul>
                    <ul className='orderNames'>
                        <li>{t('orderList.symb')}</li>
                        <li>{t('orderList.size')}</li>
                        <li>{t('orderList.entryPrice')}</li>
                        <li>{t('orderList.margin')}</li>
                        <li>{t('orderList.liquidationPrice')}</li>
                        <li>{t('orderList.pnlRoe')}</li>
                        <li>{t('orderList.takeProfit')}</li>
                        <li>{t('orderList.stopLoss')}</li>
                        
                    </ul>
                    {userOrdersOpen.map(ordersTable=>
                        <OrderList
                            key={ordersTable.id}
                            size={ordersTable.margin * ordersTable.leverage}
                            avg={AVGdata.lastPrice}
                            date={ordersTable.time}
                            isLong={ordersTable.short_long}
                            price={ordersTable.price}
                            coin={ordersTable.name}
                            coinfrom={ordersTable.coin}
                            amount={ordersTable.amount}
                            filled={ordersTable.filled}
                            total={ordersTable.total}
                            action={ordersTable.action}
                            id={ordersTable.id}
                            chlen={true}
                            marzha={ordersTable.margin}
                            wasOpen={ordersTable.was_opened}
                            pnl={ordersTable.pnl}
                            pnlPercent={ordersTable.pnl_percent}
                            leverage={ordersTable.leverage}
                            takeProfit={ordersTable.take_profit}
                            stopLoss={ordersTable.stop_loss}
                            requireUserData={requireUserDataOpen}
                            requireUserBalance={requireUserBalance}
                        />)}
                </ul>
            :
            <div className="nullListsWrapper">
                <span className='nullLists'>{t("ordser.visibleOpenOrder1")}<br/>{t("ordser.visibleOpenOrder2")}</span>
            </div>
                
            }
        </div>}
        {activeList === 2 && <div className={orders.length > 0 ? "order-list" : "order-list null-order-list"}>
            {isLoadedOrdersTable ?
                <ul>
                    <ul className='orderNames'>
                        <li>{t('orderList.symb')}</li>
                        <li>{t('orderList.size')}</li>
                        <li>{t('orderList.entryPrice')}</li>
                        <li>{t('orderList.margin')}</li>
                        <li>{t('orderList.liquidationPrice')}</li>
                        <li>{t('orderList.pnlRoe')}</li>
                        <li>{t('orderList.takeProfit')}</li>
                        <li>{t('orderList.stopLoss')}</li>
                    </ul>
                    {userOrdersClose.map(ordersTable=>
                        <OrderList
                            key={ordersTable.id}
                            closed={true}
                            waiting={false}
                            size={ordersTable.margin * ordersTable.leverage}
                            avg={AVGdata.lastPrice}
                            date={ordersTable.time}
                            isLong={ordersTable.short_long}
                            price={ordersTable.price}
                            coin={ordersTable.name}
                            coinfrom={ordersTable.coin}
                            amount={ordersTable.amount}
                            filled={ordersTable.filled}
                            total={ordersTable.total}
                            action={ordersTable.action}
                            id={ordersTable.id}
                            chlen={true}
                            marzha={ordersTable.margin}
                            wasOpen={ordersTable.was_opened}
                            pnl={ordersTable.pnl}
                            pnlPercent={ordersTable.pnl_percent}
                            leverage={ordersTable.leverage}
                            takeProfit={ordersTable.take_profit}
                            stopLoss={ordersTable.stop_loss}
                            requireUserData={requireUserDataOpen}
                            requireUserBalance={requireUserBalance}
                        />)}
                </ul>
            :
            <div className="nullListsWrapper">
                <span className='nullLists'>{t("ordser.visibleOpenOrder1")}<br/>{t("ordser.visibleOpenOrder2")}</span>
            </div>

            }
        </div>}
        {activeList === 3 && <div className={orders.length > 0 ? "order-list" : "order-list null-order-list"}>
            {isLoadedOrdersTable ?
                <ul>
                    <ul className='orderNames'>
                        <li>{t('orderList.symb')}</li>
                        <li>{t('orderList.size')}</li>
                        <li>{t('orderList.entryPrice')}</li>
                        <li>{t('orderList.margin')}</li>
                        <li>{t('orderList.liquidationPrice')}</li>
                        <li>{t('orderList.pnlRoe')}</li>
                        <li>{t('orderList.takeProfit')}</li>
                        <li>{t('orderList.stopLoss')}</li>
                    </ul>
                    {userOrdersWaiting.map(ordersTable=>
                        <OrderList
                            key={ordersTable.id}
                            closed={false}
                            waiting={true}
                            size={ordersTable.margin * ordersTable.leverage}
                            avg={AVGdata.lastPrice}
                            date={ordersTable.time}
                            isLong={ordersTable.short_long}
                            price={ordersTable.price}
                            coin={ordersTable.name}
                            coinfrom={ordersTable.coin}
                            amount={ordersTable.amount}
                            filled={ordersTable.filled}
                            total={ordersTable.total}
                            action={ordersTable.action}
                            id={ordersTable.id}
                            chlen={true}
                            marzha={ordersTable.margin}
                            wasOpen={ordersTable.was_opened}
                            pnl={ordersTable.pnl}
                            pnlPercent={ordersTable.pnl_percent}
                            leverage={ordersTable.leverage}
                            takeProfit={ordersTable.take_profit}
                            stopLoss={ordersTable.stop_loss}
                            requireUserData={requireUserDataOpen}
                            requireUserBalance={requireUserBalance}
                        />)}
                </ul>
            :
            <div className="nullListsWrapper">
                <span className='nullLists'>{t("ordser.visibleOpenOrder1")}<br/>{t("ordser.visibleOpenOrder3")}</span>
            </div>

            }
        </div>}

        {/* <div className="buttons">
            <Button text={"Купить/Лонг"} onClick={() => {
                setOrderType(1)
                setStateBuyOrder(true)
            }}/>
            <Button text={"Продать/Шорт"} onClick={() => {
                setOrderType(2)
                setStateBuyOrder(true)
            }}/>
        </div> */}
    </div>
  )
}

export default Orders